import { get } from 'api';

export const getSDKVersion = () => {
  return get('/sdks');
};
